/*eslint-disable no-unused-vars*/

import { Component } from 'react';
import { connect, PromiseState } from 'react-refetch';
import { Link } from 'react-router';
import classNames from 'classnames';
import Helmet from 'react-helmet';

import $ from 'jquery';

import { api, titles } from '../data';
import LoadingAnimation from './modules/LoadingAnimation';
import Title from './modules/Title';

class Donate extends Component {

  openBox() {
    $('.details-btn').on('click', () => {
      $('.details-btn').toggleClass('hide');
      $('.content--donate').toggleClass('hide');
    });
  }

  switchTab() {
    $('.donate__info__tab > li').on('click', (e) => {
      $('.donate__info__tab > li').removeClass('active');
      $('.donate__info__panel > li').removeClass('active');

      $(e.currentTarget).addClass('active');
      let index = $('.donate__info__tab > li').index(e.currentTarget);
      $('.donate__info__panel > li').eq(index).addClass('active');
    });
  }

  componentDidMount() {
    this.openBox();
    this.switchTab();
  }

  render() {

    const { donate, account_info } = this.props.page.acf;

    return (
      <div>
        <Helmet title={titles.home} titleTemplate={titles.titleTemplate} />
        <section className="block block--donate">
          <Title header="h1" title="支援・寄付のお願い" />
          <div className="details-btn">
            <p>支援・寄付に関する内容はここをクリックしてください。</p>
          </div>
          <div className="block__inner content--donate hide">
            <div className="donate__desc" dangerouslySetInnerHTML={{__html: donate}} />
            {account_info
              ?
                <div className="donate__info">
                  <ul className="donate__info__tab">
                    {
                      account_info.map((item, index) => {
                        let activeClass = index === 0 ? 'active' : '';
                        return ( <li className={activeClass} key={item.way}>{item.way}</li> )
                      })
                    }
                  </ul>
                  <ul className="donate__info__panel">
                    {
                      account_info.map((item, index) => {
                        let activeClass = index === 0 ? 'active' : '';
                        return ( <li className={activeClass} key={item.account} dangerouslySetInnerHTML={{__html: item.account}}></li> )
                      })
                    }
                  </ul>
                </div>
              : ''
            }
          </div>
        </section>
      </div>
    )
  }
}

class News extends Component {
  render() {

    const news = this.props.news;

    return (
      <section className="block block--news">
        <Title header="h1" title="新着情報" />
        {news
          ?
            <div className="block__inner">
              {news.map(item => {

                // split all html tag
                // and shorten strings less than 140
                // and add "..." at the end of strings
                item.content.rendered = item.content.rendered.replace(/(<([^>]+)>)/ig,"").substr(0, 140) + '...';

                return(
                  <article className="news__item" key={item.id}>
                    <div className="news__item__info">
                      <time className="news__item__date"><i className="ion-calendar" />{item.modified.split('T')[0].replace(/-/g, '/')}</time>
                      <h2 className="news__item__title">{`「${item.title.rendered}」`}</h2>
                    </div>
                    <div className="news__item__content">
                      <p>{item.content.rendered}</p>
                      <p className="read-more-btn"><Link to={`/news/${item.slug}`}>つづきを読む</Link></p>
                    </div>
                  </article>
                )
              })}
              <div className="read-news-btn"><Link to="/news"><i className="ion-ios-book" />他の更新情報もみる</Link></div>
            </div>
          : ''
        }
      </section>
    )
  }
}

class Services extends Component {
  render() {

    const { services } = this.props.page.acf;

    return (
      <section className="block block--service">
        <Title header="h1" title="事業と活動" />
        {services
          ?
            <div className="block__inner">
              {services.map(item => {
                return (
                  <div className="service__item" key={item.name}>
                    <Link to={`/services/${item.slug}`}>
                      <figure className="service__item__img" style={{'backgroundImage': `url(${item.img})`}}>
                        <figcaption className="service__item__caption">{item.name}</figcaption>
                      </figure>
                    </Link>

                      {item.services
                        ?
                          <div className="service__item__projects">
                            {item.services.map(subItem => {
                              return (
                                <div className={classNames({
                                    'service__item__sub-item': true,
                                    'item-one': item.services.length === 1,
                                    'item-two': item.services.length === 2,
                                    'item-many': item.services.length >= 3
                                })} key={subItem.url}>
                                  <h3 className="sub-item__title"><Link to={`/services/${item.slug}${subItem.url}`}>{subItem.title}</Link></h3>
                                  <div>
                                    {subItem.sub_services
                                      ? subItem.sub_services.map(subServiceItem => {
                                        // skip senior life suport temporarily
                                        if(subServiceItem.title === '高齢者生活支援') {
                                          return;
                                        }
                                        return (
                                          <p className="sub-item__sub-service__title" key={subServiceItem.url}>
                                            <Link to={`/services/${item.slug}${subServiceItem.url}`}>{subServiceItem.title}</Link>
                                          </p>
                                        )
                                      })
                                      : ''
                                    }
                                  </div>
                                </div>
                              )
                            })}
                          </div>
                        : ''
                      }
                  </div>
                )
              })}
            </div>
          : ''
        }
      </section>
    )
  }
}

class Home extends Component {
  render() {
    return (
      <div>
        <Services page={this.props.page} />
        <News page={this.props.page} news={this.props.news} />
        {/* <Donate page={this.props.page} /> */}
      </div>
    )
  }
}

class HomeFetch extends Component {
  render() {

    const { pageFetch, newsFetch } = this.props;
    const allFetches = PromiseState.all([pageFetch, newsFetch])

    // Pending
    if (allFetches.pending) {

      return <LoadingAnimation />

    // Error
    } else if (allFetches.rejected) {

      return <div>Error</div>

    // Complete without Error
    } else if (allFetches.fulfilled) {

      let [page, news] = allFetches.value;
      page = page[0];

      return (
        <div>
          <Home page={page} news={news} />
        </div>
      )
    }
  }
}

export default connect(() => ({
  pageFetch: `${api.base_url}/pages?slug=home`,
  newsFetch: `${api.base_url}/posts?filter[posts_per_page]=${api.home.posts_per_page}`
}))(HomeFetch);



/** WEBPACK FOOTER **
 ** ./src/components/Home.js
 **/